import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  SetState,
  GetState,
} from '../../components/DailyAgenda/state/createState';
import { initServices } from './initServices/initServices';
import { initSlots } from './initSlots/initSlots';
import { initAvailableDays } from './initAvailableDays/initAvailableDays';
import { initBookings } from './initBookings/initBookings';
import { AsyncComponentDataStatus } from '../../components/DailyAgenda/state/types';
import { DailyAgendaBiLogger } from '../../utils/bi/biLogger';
import { initIsPremium } from './initIsPremium/initIsPremium';
import { TriggeredByOptions } from '../../utils/bi/consts';

export type InitiatorsArgs = {
  flowAPI: ControllerFlowAPI;
  setState: SetState;
  getState: GetState;
  biLogger?: DailyAgendaBiLogger;
};

export const initWidgetData = (args: InitiatorsArgs) => {
  initServices(args);
  initSlots(args, TriggeredByOptions.INITIALIZE_WIDGET);
  initAvailableDays(args, TriggeredByOptions.INITIALIZE_WIDGET).then(() => {
    const { availableDays } = args.getState();
    if (availableDays.status === AsyncComponentDataStatus.IDLE) {
      args.biLogger?.reportDatePickerLoad(
        availableDays.data,
        TriggeredByOptions.INITIALIZE_WIDGET,
      );
    }
  });
  initBookings(args);
  initIsPremium(args);
  args.biLogger?.reportWidgetLoad();
};
